import { atomFamily, selectorFamily } from "recoil"
import { notificationSettingsSelector } from "src/recoil/selectors/settings/notificationSettingsSelector"

export const isReplyEmailEnabledStateFamily = atomFamily<boolean | undefined, string>({
  key: "atoms/settings/notifications/isReplyEmailEnabledStateFamily",
  default: selectorFamily<boolean | undefined, string>({
    key: "atoms/settings/notifications/isReplyEmailEnabledStateFamily_default",
    get:
      (organizationId) =>
      ({ get }) => {
        const settings = get(notificationSettingsSelector)
        if (settings == null) {
          return
        }
        const settingSelect = settings.find((e) => e.teamId === organizationId)
        return settingSelect?.threadMessageReceivedNotice.email
      },
  }),
})
